import { useState, useEffect } from 'react';
import styles from './styles.module.scss';
import TabsContainer from './Tabs';
import KeonController from './KeonController';
import PowerBlowController from './PowerBlowController';
import PowerShotController from './PowerShotController';
import { useAppLogic } from '../../../hooks/AppLogicHook';

const Controller = ({
  intensity,
  setIntensity,
  positions,
  setPositions,
  isRangeMode,
  setIsRangeMode,
  customSettings,
  setCustomSettings,
  isPowerShotConnected,
  firstMotorPercent,
  setFirstMotorPercent,
  secondMotorPercent,
  setSecondMotorPercent,
}) => {
  const {
    isToggleDeviceButtonVisible,
    isStrokerConnected,
    strokerDeviceName,
    powerShotDeviceName,
    powerBlowDeviceName,
  } = useAppLogic();

  const tabs = [];
  if (isStrokerConnected) { tabs.push(strokerDeviceName); }
  if (isToggleDeviceButtonVisible) { tabs.push(powerBlowDeviceName); }
  if (isPowerShotConnected) { tabs.push(powerShotDeviceName); }

  const showTabs = tabs.length > 1;

  const [selectedTab, setSelectedTab] = useState(null);

  // Keep selectedTab in sync when device list changes
  useEffect(() => {
    if (tabs.length > 0 && !tabs.includes(selectedTab)) {
      setSelectedTab(tabs[0]);
    }
  }, [isToggleDeviceButtonVisible, isPowerShotConnected, isStrokerConnected]);

  return (
    <div>
      <div className={styles.container}>
        {showTabs && (
          <TabsContainer tabs={tabs} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
        )}
        <div className={selectedTab !== strokerDeviceName ? styles.hidden : ''}>
          <KeonController
            intensity={intensity}
            setIntensity={setIntensity}
            positions={positions}
            setPositions={setPositions}
            isRangeMode={isRangeMode}
            setIsRangeMode={setIsRangeMode}
          />
        </div>
        <div className={selectedTab !== powerBlowDeviceName ? styles.hidden : ''}>
          <PowerBlowController
            customSettings={customSettings}
            setCustomSettings={setCustomSettings}
          />
        </div>
        <div className={selectedTab !== powerShotDeviceName ? styles.hidden : ''}>
          <PowerShotController
            firstMotorPercent={firstMotorPercent}
            setFirstMotorPercent={setFirstMotorPercent}
            secondMotorPercent={secondMotorPercent}
            setSecondMotorPercent={setSecondMotorPercent}
          />
        </div>
      </div>
    </div>
  );
};

export default Controller;
